import type { OverridedMixpanel } from "mixpanel-browser";
import { createContext } from "react";

import type { HallowABFlag } from "../types/enums/HallowABFlag.enum";

/** I would love to remove this just as soon as Mixpanel includes flags in their TS types */
export interface MixpanelWithFlags extends OverridedMixpanel {
  flags: {
    are_flags_ready: () => boolean;
    update_context: (context: any) => void;
    get_variant: (
      key: string,
      fallback: any,
    ) => Promise<{ key: string; value: any }>;
    get_variant_sync: (
      key: string,
      fallback: any,
    ) => { key: string; value: any };
    get_variant_value: (key: string, fallback: any) => Promise<any>;
    get_variant_value_sync: (key: string, fallback: any) => any;
  };
}

export type MixpanelContext = {
  getVariant: (
    key: HallowABFlag,
    fallback: "control" | "treatment" | "excluded",
  ) => Promise<"control" | "treatment" | "excluded">;
  isLoading: boolean;
  updateContext: (context: any) => void;
};

export const mixpanelContext = createContext<MixpanelContext>({
  updateContext: () => {},
  isLoading: true,
  getVariant: () => Promise.resolve("excluded"),
});
